const ITEMS = [
  'сыграно 184 392 партий',
  'самая длинная мафия: 4ч 12м',
  'комната «у Вани» ждёт игроков',
  'в alias сегодня победили девочки',
  'квиз про 90-е прошли 4%',
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="marq" aria-hidden="true">
      <div className="marq-row">
        {row.map((t, i) => (
          <span key={i} style={{ display: 'inline-flex', gap: 56 }}>
            <span>{t}</span>
            <span className="sep">—</span>
          </span>
        ))}
      </div>
      <style>{`
        .marq { padding: 13px 0; overflow: hidden; border-top: 1px solid var(--line); border-bottom: 1px solid var(--line); }
        .marq-row { display: flex; gap: 56px; font-family: 'JetBrains Mono', monospace; font-size: 12px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-dim); animation: scroll 60s linear infinite; width: max-content; }
        .marq-row .sep { color: var(--accent); }
        @keyframes scroll { to { transform: translateX(-50%); } }
        @media (prefers-reduced-motion: reduce) { .marq-row { animation: none; } }
      `}</style>
    </div>
  );
}
